import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    search: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'userTag/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_USER_TAGS_REQUEST,
                        types.SEARCH_USER_TAGS_SUCCESS,
                        types.SEARCH_USER_TAGS_FAILURE
                    ]
                }
            });
        },
    saveUserTag: (userTag) =>
        (dispatch) => {
            if (userTag.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'userTag/create',
                        method: 'POST',
                        body: userTag,
                        types: [
                            types.CREATE_USER_TAG_REQUEST,
                            types.CREATE_USER_TAG_SUCCESS,
                            types.CREATE_USER_TAG_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'userTag/update',
                        method: 'PUT',
                        body: userTag,
                        types: [
                            types.UPDATE_USER_TAG_REQUEST,
                            types.UPDATE_USER_TAG_SUCCESS,
                            types.UPDATE_USER_TAG_FAILURE
                        ]
                    }
                });
            }
        } 
}